"use client";

import { useEffect, useState } from "react";

/**
 * Single shared `isMobile` subscription, parameterized by breakpoint.
 *
 * Replaces the inline `useEffect + addEventListener('resize', ...)` pattern
 * that was duplicated across multiple layouts. Call sites: app/(protected)/(app)/layout.tsx
 * (768), app/(protected)/(app)/account/layout.tsx (768), app/(protected)/(app)/support/page.tsx (768),
 * app/(protected)/(app)/task/layout.tsx (1024).
 */
export function useIsMobile(breakpoint = 768): boolean {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < breakpoint);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, [breakpoint]);

  return isMobile;
}
